function SubsystemModalController(eventService, ConditionService) {
  const ctrl = this;

  ctrl.$onInit = () => {
    ctrl.subSystemObject = angular.copy(ctrl.resolve.subSystemObject);
  };

  ctrl.selectAsset = event => {
    ctrl.selectedAsset = event.asset;
  };

  ctrl.onGraphVisible = event => {
    ctrl.chartVisible = event;
  };

  ctrl.onConfigVisible = async (event) => {
    ctrl.selectedConfig = await ConditionService.getCiConfig({
      ciType: event.config,
    });
  };

  ctrl.goToPrevious = () => {
    if (ctrl.chartVisible) {
      ctrl.chartVisible = null;
    } else if (ctrl.selectedConfig) {
      ctrl.selectedConfig = null;
    } else {
      ctrl.selectedAsset = null;
    }
  };

  ctrl.save = () => {
    ctrl.close();
  };

  ctrl.cancel = () => {
    ctrl.dismiss({ $value: 'cancel' });
  };

  eventService.on('return-ci-list', function() {
    ctrl.goToPrevious();
  });

}

angular.module('modalDirectives').controller('SubsystemModalController', SubsystemModalController);
